<template>
    <base-section
    :id="title"
    >
    <base-section-heading :title="title">
    <v-row
    justify="center"
    >
      <v-img
      max-width="150"
      :src="image"
      >
      </v-img>
    </v-row>
    </base-section-heading>
    <base-section-heading title="Website">
    Here you can visit the official website of the workshop: <a
    target="_blank"
    :href="website"
    >{{ website }}</a>
    </base-section-heading>
      <base-section-heading
      title="Abstract"
      >
      {{ abstract }}
      </base-section-heading>
    <base-section-heading
      title="Chairs"
      >
      <span
      v-html="chairs"
      >
      </span>
      </base-section-heading>
      <base-section-heading
      title="Key Dates"
      >
      <v-data-table
        :headers="headers"
        :items="dates"
        :items-per-page="-1"
        item-key="name"
        hide-default-footer
        class="elevation-1"
      >
        <template v-slot:[`item.date`]="{ item }">
          <span
          v-html="item.date"
          >
          </span>
        </template>
      </v-data-table>
      <br>
      </base-section-heading>
  </base-section>
</template>

<script>
  export default {
    name: 'WsPage',

    props: {
        title: String,
        chairs: String,
        abstract: String,
        website: String,
        image: String,
        dates: Array,
    },

    data: () => ({
      headers: [
        {
          text: 'Deadline Date',
          value: 'date',
          sortable: false,
          align: 'right',
        },
        {
          text: 'Type',
          value: 'name',
          sortable: false,
          align: 'left',
        },
      ],
    }),

  }
</script>
